<template>
  <div class="content-wrap">
    <div class="card-header">
      <h3 class="title"></h3>
      <el-button type="primary"
                 @click="handleChapterAdd">添加一级章节</el-button>
    </div>
    <div class="table-wrap">
      <el-table ref="table"
                :data="results"
                style="width: 100%"
                row-key="id"
                :default-expand-all="false"
                :expand-row-keys="expands"
                @expand-change="handleExpendChange"
                row-class-name="row-item"
                :tree-props="{ children: 'children' }">
        <el-table-column class-name="title-cell"
                         prop="name"
                         label="章节"
                         width="300">
          <template slot-scope="scope">
            <input class="input"
                   v-model="scope.row.name"
                   v-focus="scope.row.id == insertId"
                   placeholder="请输入章节标题"
                   @blur="handleTitleChange(scope.row, $event)" />
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="在线状态"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status"
                    type="success">已发布</el-tag>
            <el-tag v-if="!scope.row.status"
                    type="warning">未发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="trial"
                         label="试看状态"
                         width="110"
                         align="center">
          <template v-if="scope.row.level !== 1"
                    slot-scope="scope">
            <el-tag v-if="scope.row.trial"
                    type="success">可试看</el-tag>
            <el-tag v-if="!scope.row.trial"
                    type="warning">不可试看</el-tag>
          </template>
        </el-table-column>
        <el-table-column class-name="edit-cell"
                         label="可见范围"
                         align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.show_status"
                       placeholder="请选择"
                       @change="handleToEditShowStatus(scope.row)">
              <el-option v-for="item in show_status"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column class-name="edit-cell"
                         label="关联教室号"
                         align="center">
          <template slot-scope="scope"
                    v-if="scope.row.baijia_resource_room_obj">
            <el-tag>{{scope.row.baijia_resource_room_obj.room_id}}</el-tag>
            <!-- <el-select v-model="scope.row.show_status"
                       placeholder="请选择"
                       @change="handleToEditShowStatus(scope.row)">
              <el-option v-for="item in show_status"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select> -->
          </template>
        </el-table-column>
        <el-table-column class-name="edit-cell"
                         label="回放时长"
                         align="center">
          <template slot-scope="scope"
                    v-if="scope.row.baijia_resource_room_video_obj">
            <el-tag>{{formatTime(scope.row.baijia_resource_room_video_obj.length)}}</el-tag>
            <!-- <el-select v-model="scope.row.show_status"
                       placeholder="请选择"
                       @change="handleToEditShowStatus(scope.row)">
              <el-option v-for="item in show_status"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select> -->
          </template>
        </el-table-column>
        <el-table-column class-name="edit-cell"
                         label="编辑"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.level === 1">
              <el-button type="text"
                         @click="handleSubChapterAdd(scope.row)">添加子级</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text"
                         v-if="scope.row.status == false"
                         @click="handleStatusChange(scope.row, true)">发布</el-button>
              <el-button type="text"
                         v-if="scope.row.status"
                         @click="handleStatusChange(scope.row, false)">下线</el-button>
            </div>
            <div v-if="scope.row.level !== 1">
              <div v-if="scope.row.extra_type==0">
                <el-button type="text"
                           @click="handleChapterToEdit(scope.row)">编辑</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text"
                           @click="handleTestToEdit(scope.row)">编辑试卷</el-button>
                <el-button type="text"
                           v-if="scope.row.status == false"
                           @click="handleStatusChange(scope.row, true)">发布</el-button>
                <el-button type="text"
                           v-if="scope.row.status"
                           @click="handleStatusChange(scope.row, false)">下线</el-button>
              </div>
              <div v-else>
                <el-button type="text"
                           v-if="scope.row.trial == false"
                           @click="handFreeChange(scope.row, true)">允许试看</el-button>
                <el-button type="text"
                           v-if="scope.row.trial"
                           @click="handFreeChange(scope.row, false)">禁止试看</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text"
                           @click="handleChapterToEdit(scope.row)">编辑</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text"
                           v-if="scope.row.status == false"
                           @click="handleStatusChange(scope.row, true)">发布</el-button>
                <el-button type="text"
                           v-if="scope.row.status"
                           @click="handleStatusChange(scope.row, false)">下线</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text"
                           @click="handlePreview(scope.row)"
                           v-if="scope.row.baijia_resource_room_video_obj">预览</el-button>
                <el-button type="text"
                           @click="handlePreview(scope.row)"
                           v-else-if="scope.row.baijia_resource_room_obj">预览</el-button>
                <el-link type="info"
                         v-else>预览</el-link>
              </div>

            </div>
          </template>
        </el-table-column>

        <el-table-column class-name="action-cell"
                         label="操作"
                         width="140"
                         align="center">
          <template slot-scope="scope">
            <div class="menu-wrap">
              <div v-if="handleActionCheck(scope.row, 'up')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'up')">上移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'down')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'down')">下移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleRemoveChapter(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CourseChapterEdit :visible="editDialog"
                       :content="chapter"
                       @close="editDialog = false"
                       @submit="fetchCourseChapterList"></CourseChapterEdit>
    <CourseChapteeCreate :visible="createDialog"
                         :content="node"
                         :product_id="product_id"
                         @close="createDialog = false"
                         @addNode="addNode"
                         @submit="ChapterList"></CourseChapteeCreate>
  </div>
</template>

<script>
import CourseChapterEdit from '@/components/dialog/course/CourseChapterEdit'
import CourseChapteeCreate from '@/components/dialog/course/CourseChapteeCreate'
import {
  courseOne,
  courseUpdateStatus,
  courseChapterList,
  courseChapterCreate,
  courseChapterUpdate,
  courseChaptersUpdate,
  courseChapterDestroy,
  getRoomVideoToken,
} from '@/api/course'

export default {
  components: {
    CourseChapterEdit,
    CourseChapteeCreate,
  },
  data() {
    return {
      editDialog: false,
      createDialog: false,
      expands: [],
      product_id: this.$route.params.courseId,
      insertId: '',
      course: {},
      chapter: {},
      node: {},
      results: [],
      show_status: [
        { label: '全部可见', value: 1 },
        { label: '列表可见', value: 2 },
        { label: '学习可见', value: 3 },
      ],
    }
  },
  created() {
    this.fetchCourseChapterList()
  },
  methods: {
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600) // 计算小时
      const minutes = Math.floor((seconds % 3600) / 60) // 计算分钟
      const remainingSeconds = seconds % 60 // 计算秒数

      if (hours > 0) {
        return `${hours}小时${minutes}分钟${remainingSeconds}秒`
      } else {
        return `${minutes}分钟${remainingSeconds}秒`
      }
    },
    ChapterList() {
      this.fetchCourseChapterList()
    },
    handleTestToEdit(row) {
      this.$router.push(
        `/course/testPaper/${this.$route.params.courseId}/paper/${row.measure_scroll_obj.id}`
      )
    },
    handlePreview(row) {
   
      if (row.baijia_resource_room_video_obj) {
        let data = {
          product_type: 1,
          course_chapter_id: row.id,
          room_id: row.baijia_resource_room_video_obj.room_id,
          video_id: row.baijia_resource_room_video_obj.video_id,
        }

        getRoomVideoToken(data).then((res) => {
          window.open(
            `https://kaoyanbox.at.baijiayun.com/web/playback/index?classid=${row.baijia_resource_room_video_obj.room_id}&token=${res.token}`
          )
        })
      } else {
        window.open(
          `https://kaoyanbox.at.baijiayun.com/web/room/prepare?room_id=${row.baijia_resource_room_obj.room_id}&code=${row.baijia_resource_room_obj.admin_code}`
        )
      }

      // if (location) {
      // let clipboardText = ''
      // if (location.host.includes('admin.kaoyanbox.com')) {
      //   if (row.baijia_resource_type == 3) {
      //     clipboardText = `https://h5.kaoyanbox.com/baijiayun/live?type=3&product_type=1&course_chapter_id=${row.id}&name=${row.name}&room_id=${row.baijia_room_id}&video_id=${row.baijia_room_video_id}&product_id=${row.__ob__.value.product_id}`
      //   } else if (row.baijia_resource_type == 2) {
      //     clipboardText = `https://h5.kaoyanbox.com/baijiayun/live?type=2&product_type=1&course_chapter_id=${row.id}&name=${row.name}&room_id=${row.baijia_room_id}&product_id=${row.__ob__.value.product_id}`
      //   } else {
      //     clipboardText = `https://h5.kaoyanbox.com/baijiayun/video?product_type=1&course_chapter_id=${row.id}&name=${row.name}&video_id=${row.baijia_video_id}&product_id=${row.__ob__.value.product_id}`
      //   }
      // } else {
      //   if (row.baijia_resource_type == 3) {
      //     clipboardText = `http://localhost:8083/baijiayun/live?type=3&product_type=1&course_chapter_id=${row.id}&name=${row.name}&room_id=${row.baijia_room_id}&video_id=${row.baijia_room_video_id}&product_id=${row.__ob__.value.product_id}`
      //   } else if (row.baijia_resource_type == 2) {
      //     clipboardText = `http://localhost:8083/baijiayun/live?type=2&product_type=1&course_chapter_id=${row.id}&name=${row.name}&room_id=${row.baijia_room_id}&product_id=${row.__ob__.value.product_id}`
      //   } else {
      //     clipboardText = `http://localhost:8083/baijiayun/video?product_type=1&course_chapter_id=${row.id}&name=${row.name}&video_id=${row.baijia_video_id}&product_id=${row.__ob__.value.product_id}`
      //   }
      // }
      //  console.log('clipboardText:', clipboardText)
      // navigator.clipboard.writeText(clipboardText).then(
      //   () => {
      //     this.$message({
      //       message: '已保存到粘贴板',
      //       type: 'success',
      //       duration: 2000,
      //     })
      //   },
      //   () => {
      //     this.$message({
      //       message: '复制链接失败',
      //       type: 'warning',
      //       duration: 2000,
      //     })
      //   }
      // )
      // }
      // console.log("oooo", row.__ob__.value.product_id);
    },
    // 课程章节列表请求
    fetchCourseChapterList() {
      courseChapterList({ product_id: this.$route.params.courseId }).then(
        (res) => {
          this.results = res.list || []

          if (!this.expands.length) {
            setTimeout(() => {
              this.results.length &&
                this.hendleToggleExpand(this.results[0], true)
            }, 100)
          }
        }
      )
    },
    // 展开行变化记录
    handleExpendChange(row, expand) {
      if (expand) {
        this.expands.push(row.id + '')
      } else {
        this.expands = this.expands.filter((item) => item != row.id)
      }
    },
    // 试看状态变更
    handFreeChange(row, trial) {
      row.trial = trial
      courseChapterUpdate({ id: row.id, trial: row.trial ? 1 : 0 })
        .then((res) => {
          this.fetchCourseChapterList()
        })
        .catch((error) => {
          this.$message.error('试看状态更新异常')
          console.log('error: ', error)
        })
    },
    // 发布状态变化
    handleStatusChange(row, status) {
      console.log(row, status)
      if (row.extra_type == 2 && !row.baijia_room_id && row.level == 2) {
        return this.$message.error('请输入直播房间ID')
      } else if (
        row.extra_type == 1 &&
        !row.baijia_video_id &&
        row.level == 2
      ) {
        return this.$message.error('请输入录播视频ID')
      }
      // if (status && row.extra_type == 2) {
      //   if (!row.baijia_video_id) {
      //     return this.$message.error('请输入录播视频ID')
      //   } else if (!row.baijia_room_id) {
      //     return this.$message.error('请输入直播房间ID')
      //   }
      // }
      row.status = status
      courseChapterUpdate({ id: row.id, status: row.status ? 1 : 0 })
        .then((res) => {
          this.fetchCourseChapterList()
        })
        .catch((error) => {
          this.$message.error('在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      let { index, list } = this.computeIndex(row.id)
      let item = list.splice(index, 1)[0]
      if (sort == 'up') {
        list.splice(index - 1, 0, item)
      } else if (sort == 'down') {
        list.splice(index + 1, 0, item)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      courseChaptersUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节排序更新异常')
          console.log('error: ', error)
        })
    },
    // 删除章节
    handleRemoveChapter(row) {
      let { index, list } = this.computeIndex(row.id)
      if (row.children && row.children.length) {
        return this.$message.error('请清除子节点后再进行删除操作')
      }
      courseChapterDestroy({ id: row.id })
        .then((res) => {
          list.splice(index, 1)[0]
        })
        .catch((error) => {
          this.$message.error('章节删除失败')
          console.log('error: ', error)
        })
    },
    // 数据位置计算
    computeIndex(id) {
      let index = null
      let length = 0
      let list = []
      this.results.some((item, i, arr) => {
        if (item.id == id) {
          index = i
          length = this.results.length
          list = arr
          return true
        }
        if (item.children) {
          item.children.some((subItem, subIndex, subArr) => {
            if (subItem.id == id) {
              index = subIndex
              length = item.children.length
              list = subArr
              return true
            }
          })
        }
      })
      return { index, length, list }
    },
    // 排序边界检查
    handleActionCheck(row, type) {
      let { index, length } = this.computeIndex(row.id)
      if (type == 'up') {
        if (index === 0) {
          return false
        }
        if (index > 0 && length > 1) {
          return true
        }
      }
      if (type == 'down') {
        if (index === length - 1) {
          return false
        }
        return true
      }
      return false
    },
    // 章节标题变化
    handleTitleChange(row) {
      courseChapterUpdate({ id: row.id, name: row.name })
        .then((res) => {
          console.log('修改3')
          this.insertId = ''
        })
        .catch((error) => {
          this.$message.error('章节标题更新异常')
          console.log('error: ', error)
        })
    },
    // 章节试卷编辑
    handleChapterToEdit(row) {
      this.chapter = row
      this.editDialog = true
    },
    // 添加章
    handleChapterAdd() {
      let newChapter = {
        product_id: this.$route.params.courseId,
        name: '',
        level: 1,
        status: 0,
      }
      courseChapterCreate(newChapter)
        .then((res) => {
          this.insertId = res.id
          res.children = []
          this.results.push(res)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    addNode(res) {
      console.log('reskkk', res)
      this.insertId = res.id
      let { index } = this.computeIndex(this.node.id)

      // 稍晚一点儿展开行
      if (this.node.children.length) {
        this.hendleToggleExpand(this.node)
      } else {
        setTimeout(() => {
          this.hendleToggleExpand(this.node)
        }, 20)
      }

      if (this.results[index].id == this.node.id) {
        this.results[index].children.push(res)
      }
    },
    // 添加节
    handleSubChapterAdd(row) {
      this.createDialog = true
      this.node = row

      // this.results.forEach((item) => {
      //   if (item.id != row.id) {
      //     this.hendleToggleExpand(item, false)
      //   }
      // })

      // let newChapter = {
      //   product_id: this.$route.params.courseId,
      //   pid: row.id,
      //   name: '',
      //   level: row.level + 1,
      //   status: 0,
      // }
      // courseChapterCreate(newChapter)
      //   .then((res) => {
      //     this.insertId = res.id
      //     let { index } = this.computeIndex(row.id)

      //     // 稍晚一点儿展开行
      //     if (row.children.length) {
      //       this.hendleToggleExpand(row)
      //     } else {
      //       setTimeout(() => {
      //         this.hendleToggleExpand(row)
      //       }, 20)
      //     }

      //     if (this.results[index].id == row.id) {
      //       this.results[index].children.push(res)
      //     }
      //   })
      //   .catch((error) => {
      //     console.log('error: ', error)
      //   })
    },
    // table row 展开状态变化
    hendleToggleExpand(row, expanded = true) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
    handleToEditShowStatus(row) {
      courseChapterUpdate({ id: row.id, show_status: row.show_status })
        .then((res) => {
          console.log('修改4')
          this.fetchCourseChapterList()
        })
        .catch((error) => {
          this.$message.error('章节可见范围更新异常')
          console.log('error: ', error)
        })
    },
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
    },
  },
}
</script>

<style scoped lang="less">
.content-wrap {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .table-wrap {
    /deep/ .title-cell {
      width: 50px;

      .cell {
        display: flex;
        align-items: center;
      }
      .input {
        width: 250px;
        height: 32px;
        line-height: 32px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #606266;
        padding: 0 15px;
        outline: 0;

        &:focus {
          background: #fff;
          border-color: #409eff !important;
        }
      }

      &:hover .input {
        background: #fff;
        border-color: #dcdfe6;
      }
    }
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      &:hover .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .menu-wrap {
        display: none;
      }
    }
    /deep/.el-input__inner {
      text-align: center;
      padding: 0px 16px;
      border: none;
      color: #409eff;
    }
    /deep/.el-input__icon {
      border: solid;
      display: none;
    }
    /deep/.el-select {
      width: 100px;
    }
  }
}
</style>
